import * as React from 'react'
import { IConnector } from '../Tools/connectors'
import ToolsConnector from '../Tools/ToolsConnector'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import './CustomMetricsPage.css'

export type ValueProps = {
  sendMetricsConnectors: IConnector[]
}

export type EventProps = {}

export type Props = ValueProps & EventProps

export class CustomMetricsPage extends React.Component<Props> {
  
  render() {
    const {sendMetricsConnectors} = this.props
    
    return (
      <div className={'custom-metrics-page-container'} data-test-id="custom-metrics-page-container">
        <div className={'custom-metrics-page-header'} data-test-id="custom-metrics-page-header">
          <div className={'custom-metrics-page-header-title custom-metrics-page'} data-test-id="custom-metrics-page-header-title">
            <IconPanel name="manage-medium" size={52}/>
          </div>
          <div className={'custom-metrics-page-header-subtitle'} data-test-id="custom-metrics-page-header-subtitle">
            <span>
              Send custom business and operational metrics to visualize in real-time in Anypoint Monitoring
            </span>
          </div>
        </div>
        <div className={'custom-metrics-body-container'} data-test-id="custom-metrics-body-container">
          <div className={'custom-metrics-connectors-row'} data-test-id="custom-metrics-connectors-row">
            <div className={'custom-metrics-connectors-container'} data-test-id="custom-metrics-connectors-container">
              {
                sendMetricsConnectors.map((connector, index) => {
                  return (
                    <ToolsConnector
                      key={index}
                      title={connector.title}
                      description={connector.description}
                      link={connector.link}
                      type={connector.type}
                    />
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}
